// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cesium-viewer-geocoderContainer .cesium-geocoder-input {
  border: solid 1px #444;
  background-color: rgba(40, 40, 40, 0.7);
  color: white;
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 32px;
  margin: 0;
  padding: 0 32px 0 0;
  border-radius: 0;
  box-sizing: border-box;
  transition:
    width ease-in-out 0.25s,
    background-color 0.2s ease-in-out;
  -webkit-appearance: none;
}

.cesium-viewer-geocoderContainer:hover .cesium-geocoder-input {
  border-color: #aef;
  box-shadow: 0 0 8px #fff;
}

.cesium-viewer-geocoderContainer .cesium-geocoder-input:focus {
  border-color: #ea4;
  background-color: rgba(15, 15, 15, 0.9);
  box-shadow: none;
  outline: none;
}

.cesium-viewer-geocoderContainer:hover .cesium-geocoder-input,
.cesium-viewer-geocoderContainer .cesium-geocoder-input:focus,
.cesium-viewer-geocoderContainer .cesium-geocoder-input-wide {
  padding-left: 4px;
  width: 250px;
}

.cesium-viewer-geocoderContainer .search-results {
  position: absolute;
  background-color: #000;
  color: #eee;
  overflow-y: auto;
  opacity: 0.8;
  width: 100%;
}

.cesium-viewer-geocoderContainer .search-results ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.cesium-viewer-geocoderContainer .search-results ul li {
  font-size: 14px;
  padding: 3px 10px;
}
.cesium-viewer-geocoderContainer .search-results ul li:hover {
  cursor: pointer;
}

.cesium-viewer-geocoderContainer .search-results ul li.active {
  background: #48b;
}

.cesium-geocoder-searchButton {
  background-color: #303336;
  display: inline-block;
  position: absolute;
  cursor: pointer;
  width: 32px;
  top: 1px;
  right: 1px;
  height: 30px;
  vertical-align: middle;
  fill: #edffff;
}

.cesium-geocoder-searchButton:hover {
  background-color: #48b;
}
`, "",{"version":3,"sources":["webpack://./cesium/Source/Widgets/Geocoder/Geocoder.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,uCAAuC;EACvC,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB;;qCAEmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,uCAAuC;EACvC,gBAAgB;EAChB,aAAa;AACf;;AAEA;;;EAGE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".cesium-viewer-geocoderContainer .cesium-geocoder-input {\n  border: solid 1px #444;\n  background-color: rgba(40, 40, 40, 0.7);\n  color: white;\n  display: inline-block;\n  vertical-align: middle;\n  width: 0;\n  height: 32px;\n  margin: 0;\n  padding: 0 32px 0 0;\n  border-radius: 0;\n  box-sizing: border-box;\n  transition:\n    width ease-in-out 0.25s,\n    background-color 0.2s ease-in-out;\n  -webkit-appearance: none;\n}\n\n.cesium-viewer-geocoderContainer:hover .cesium-geocoder-input {\n  border-color: #aef;\n  box-shadow: 0 0 8px #fff;\n}\n\n.cesium-viewer-geocoderContainer .cesium-geocoder-input:focus {\n  border-color: #ea4;\n  background-color: rgba(15, 15, 15, 0.9);\n  box-shadow: none;\n  outline: none;\n}\n\n.cesium-viewer-geocoderContainer:hover .cesium-geocoder-input,\n.cesium-viewer-geocoderContainer .cesium-geocoder-input:focus,\n.cesium-viewer-geocoderContainer .cesium-geocoder-input-wide {\n  padding-left: 4px;\n  width: 250px;\n}\n\n.cesium-viewer-geocoderContainer .search-results {\n  position: absolute;\n  background-color: #000;\n  color: #eee;\n  overflow-y: auto;\n  opacity: 0.8;\n  width: 100%;\n}\n\n.cesium-viewer-geocoderContainer .search-results ul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n}\n\n.cesium-viewer-geocoderContainer .search-results ul li {\n  font-size: 14px;\n  padding: 3px 10px;\n}\n.cesium-viewer-geocoderContainer .search-results ul li:hover {\n  cursor: pointer;\n}\n\n.cesium-viewer-geocoderContainer .search-results ul li.active {\n  background: #48b;\n}\n\n.cesium-geocoder-searchButton {\n  background-color: #303336;\n  display: inline-block;\n  position: absolute;\n  cursor: pointer;\n  width: 32px;\n  top: 1px;\n  right: 1px;\n  height: 30px;\n  vertical-align: middle;\n  fill: #edffff;\n}\n\n.cesium-geocoder-searchButton:hover {\n  background-color: #48b;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
